import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

export function OfflineBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="bg-amber-900/80 border-b border-amber-700 px-4 py-2.5 text-center">
      <div className="flex items-center justify-center gap-2 text-sm font-medium text-amber-200">
        <WifiOff className="h-4 w-4 flex-shrink-0" />
        <span>You're offline. Some features may be unavailable.</span>
      </div>
    </div>
  );
}
